import { AlertTriangle } from "lucide-react";

export const LeakBadges = ({ flags, prefix }) => {
  if (!flags.length) return null;
  return (
    <div className="flex flex-wrap gap-1.5">
      {flags.map((f) => (
        <span key={f.key} data-testid={`${prefix}-leak-${f.key}`} className="leak-badge">
          <AlertTriangle className="h-3 w-3" strokeWidth={2.5} />
          {f.label}
        </span>
      ))}
    </div>
  );
};
